// extracted by mini-css-extract-plugin
export default {"activeModeChip":"SearchInput_activeModeChip__XYYsF","searchButton":"SearchInput_searchButton__C5EtT"};